module.exports = __webpack_public_path__ + "static/desktop/img/production-tablet-photobook.d7c566b4.png";